import { Phone, MessageCircle } from "lucide-react";

// Free click-to-call (tel:) and click-to-WhatsApp (wa.me) — no WhatsApp API involved.
// Assumes Indian numbers; strips to the last 10 digits and prefixes +91 / 91.
export function ContactActions({ phone, message = "", size = "md", suffix = "", className = "" }) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length < 10) return null;
  const local = digits.slice(-10);
  const tel = `tel:+91${local}`;
  const wa = `https://wa.me/91${local}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  const cls = size === "sm" ? "w-7 h-7" : "w-9 h-9";
  const stop = (e) => e.stopPropagation();
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <a href={tel} onClick={stop} title="Call" aria-label="Call" data-testid={`click-to-call${suffix}`}
        className={`${cls} inline-flex items-center justify-center rounded-full border border-[#E6E8F0] text-[#101D51] hover:bg-[#F5F6FA] transition-colors`}>
        <Phone className="w-4 h-4" />
      </a>
      <a href={wa} target="_blank" rel="noopener noreferrer" onClick={stop} title="WhatsApp" aria-label="WhatsApp" data-testid={`click-to-whatsapp${suffix}`}
        className={`${cls} inline-flex items-center justify-center rounded-full bg-[#25D366] text-white hover:bg-[#1eb955] transition-colors`}>
        <MessageCircle className="w-4 h-4" />
      </a>
    </div>
  );
}
